import Api from './api';
import Event from 'models/event';
import { JsonApiResponse, toJsonApiResponse } from 'utils/json-api';

export default class EventsService {
    static async fetchEvents(): Promise<JsonApiResponse<Event[]>> {
        let response = await Api.get('events');
        return await toJsonApiResponse<Event[]>(response);
    }
}